import { useEffect, useState } from '@frontend/react';

export const useDragState = () => {
  const [isDragging, setIsDragging] = useState(false);

  useEffect(() => {
    const handleDragOver = () => setIsDragging(true);
    const handleDragLeave = () => setIsDragging(false);
    const handleDrop = () => setIsDragging(false);

    window.addEventListener('dragover', handleDragOver);
    window.addEventListener('dragleave', handleDragLeave);
    window.addEventListener('drop', handleDrop);

    return () => {
      window.removeEventListener('dragover', handleDragOver);
      window.removeEventListener('dragleave', handleDragLeave);
      window.removeEventListener('drop', handleDrop);
    };
  }, []);

  return isDragging;
};
